// :cow: Cosmose CONFIDENTIAL :iso:
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {ConfigService} from '@par/app/core/services/config.service';
import {CustomDomainsResponse, DomainListResponse} from '@par/app/core/model/custom-domains.response';

@Injectable({providedIn: 'root'})
export class SelectDomainService {
  private domains$: Observable<CustomDomainsResponse>;

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getDomainList(): Observable<DomainListResponse> {
    return this.getDomains()
      .pipe(
        map((dictionaries) => {
          return dictionaries.map((element) => ({label: element.id.toString(), value: element.id.toString()}));
        }),
      );
  }

  getDomains(): Observable<CustomDomainsResponse> {
    if (!this.domains$) {
      const url = this.configService.getConfig().kknowContentApi + '/custom-domain';
      this.domains$ = this.httpClient.get<CustomDomainsResponse>(url)
        .pipe(shareReplay({bufferSize: 1, refCount: true}));
    }

    return this.domains$;
  }
}
